import { useEffect } from "react";
const useResetScroll = (ref, pathName) => {
  useEffect(() => {
    var _a;
    (_a = ref.current) == null ? void 0 : _a.scrollTo(0, 0);
  }, [pathName, ref]);
};
const useResetScroll$1 = useResetScroll;
export {
  useResetScroll$1 as default
};
